import React from "react";
import "./Contact.css";
import { VscGithub } from "react-icons/vsc";
import { CgMail } from "react-icons/cg";
import { BsFillTelephoneFill } from "react-icons/bs";
import { ThemeContext } from "../../Context/theme";

import { FaLinkedin } from "react-icons/fa";
export const Contact = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <div className="section">
        <h2 className="section__title" data-aos="fade-right" id="contact-heading">
          Contact <span className="different">Aman Jaiswal</span>
        </h2>
        <p className="contact__desc" data-aos="fade-right">
          Hiring an Angular or React developer, or need a frontend developer for
          a project? Email or call me — I reply to every message.
        </p>
        <div className="contactMain">
          <div
            className={"contactcontainer " + themename}
            data-aos="fade-right"
          >
            <a
              href="https://www.linkedin.com/in/aman-jaiswal-39a9b1254"
              target="_blank"
              rel="me noopener noreferrer"
              aria-label="Aman Jaiswal on LinkedIn"
              title="Aman Jaiswal — Frontend Developer on LinkedIn"
            >
              <FaLinkedin className="linkedin" />
            </a>
            <a
              href="https://github.com/AMAN-JAISWALL"
              target="_blank"
              rel="me noopener noreferrer"
              aria-label="Aman Jaiswal on GitHub"
              title="Aman Jaiswal — Angular and React projects on GitHub"
            >
              <VscGithub className="github" />
            </a>
            <a
              href="mailto:aj27757@gmail.com"
              aria-label="Email Aman Jaiswal"
              title="Email Aman Jaiswal, frontend developer in India"
            >
              <CgMail className="email" />
            </a>
            <a
              href="tel:+917974999575"
              aria-label="Call Aman Jaiswal"
              title="Call Aman Jaiswal"
            >
              <BsFillTelephoneFill className="phone" />
            </a>
          </div>
          <div className="mailNumber" data-aos="fade-right">
            <div>
              <span>
                <CgMail className="email" />
              </span>
              <span>
                <p>aj27757@gmail.com</p>
              </span>
            </div>
            <div className="iconsCont">
              <span>
                <BsFillTelephoneFill className="phone" />
              </span>
              <span>
                <p>+91 7974999575</p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
